"use strict";

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _createForOfIteratorHelper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var eth_sdk_1 = require("eth-sdk");

var constants_1 = require("../constants");

var KChannelsModule = /*#__PURE__*/function () {
  function KChannelsModule(sdk) {
    _classCallCheck(this, KChannelsModule);

    this.sdk = sdk;
    this.state$ = new KChannelsModule.State();
  }

  _createClass(KChannelsModule, [{
    key: "authenticate",
    value: function authenticate() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$sdk, kChannels, authKey, authData, kChannelsAuth;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$sdk = this.sdk, kChannels = _this$sdk.clients.kChannels, authKey = _this$sdk.modules.authKey;
                _context.next = 3;
                return kChannels.getAuthenticationChallengeTypedMessage(authKey.address);

              case 3:
                authData = _context.sent;
                authData.data['signature'] = authKey.signTypedMessage(authData.typedMessage);
                _context.next = 7;
                return kChannels.authenticate(authData.data);

              case 7:
                kChannelsAuth = _context.sent;

                if (this.state) {
                  this.state$.update({
                    jwt: kChannelsAuth.jwt,
                    exp: kChannelsAuth.exp
                  });
                } else {
                  this.state$.next(kChannelsAuth);
                }

                return _context.abrupt("return", this.state.jwt);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "createChannel",
    value: function createChannel() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result, _this$sdk2, kChannels, _this$sdk2$modules, authKey, account, clientInformation, ownerAuthKeyAddresses, channelDefinitionToSign, updateChannelDefinitionBody, typedMessage, signedMessage;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = this.state;

                if (result) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('you must authenticate first');

              case 3:
                this.validateTokenExpiration();
                _this$sdk2 = this.sdk, kChannels = _this$sdk2.clients.kChannels, _this$sdk2$modules = _this$sdk2.modules, authKey = _this$sdk2$modules.authKey, account = _this$sdk2$modules.account;
                _context2.next = 7;
                return kChannels.getClientInformation(this.state$.getValue().jwt);

              case 7:
                clientInformation = _context2.sent;
                _context2.next = 10;
                return this.getOwnerAuthKeyAddresses();

              case 10:
                ownerAuthKeyAddresses = _context2.sent;

                if (!(clientInformation.channel_definition && eth_sdk_1.toChecksumAddress(clientInformation.channel_definition.deposit_address) === eth_sdk_1.toChecksumAddress(account.address) && this.hasValidSigners(clientInformation.channel_definition.sender_address_list, ownerAuthKeyAddresses))) {
                  _context2.next = 15;
                  break;
                }

                this.state$.update({
                  channelDefinition: clientInformation.channel_definition,
                  zoneLocation: clientInformation.zone_location
                });
                this.createWebSocketConnections();
                return _context2.abrupt("return", clientInformation.channel_definition);

              case 15:
                _context2.next = 17;
                return kChannels.createChannelDefinition(this.state$.getValue().jwt);

              case 17:
                channelDefinitionToSign = _context2.sent;
                updateChannelDefinitionBody = channelDefinitionToSign.result;
                updateChannelDefinitionBody['sender_address_list'] = ownerAuthKeyAddresses.length === 0 ? updateChannelDefinitionBody['sender_address_list'] : ownerAuthKeyAddresses;
                updateChannelDefinitionBody['deposit_address'] = account.address;
                typedMessage = kChannels.getChannelDefinitionTypedMessage(updateChannelDefinitionBody);
                signedMessage = authKey.signTypedMessage(typedMessage);
                updateChannelDefinitionBody['signature_list'] = [signedMessage];
                _context2.next = 26;
                return kChannels.updateChannelDefinition(this.state$.getValue().jwt, updateChannelDefinitionBody);

              case 26:
                _context2.next = 28;
                return kChannels.getClientInformation(this.state$.getValue().jwt);

              case 28:
                clientInformation = _context2.sent;
                this.state$.update({
                  channelDefinition: clientInformation.channel_definition,
                  zoneLocation: clientInformation.zone_location
                });
                this.createWebSocketConnections();
                return _context2.abrupt("return", this.state$.getValue().channelDefinition);

              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "createWebSocketConnections",
    value: function createWebSocketConnections() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.createChannelWebSocketConnection();
                this.createTransactionWebSocketConnection();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "createChannelWebSocketConnection",
    value: function createChannelWebSocketConnection() {
      var _this = this;

      var result = this.state;

      if (result.channelWsConnection) {
        result.channelWsConnection.close();
        this.state$.update({
          channelWsConnection: null
        });
      }

      var _this$sdk3 = this.sdk,
          kChannels = _this$sdk3.clients.kChannels,
          notification = _this$sdk3.modules.notification;
      var channelWebSocketConnection = kChannels.createChannelWebSocketConnection(this.state$.getValue().zoneLocation.zone_client_endpoint, this.state$.getValue().channelDefinition, this.state$.getValue().jwt);

      channelWebSocketConnection.onmessage = function (message) {
        var result = JSON.parse(message.data);

        _this.state$.update({
          assetList: result.channel_state.channel_asset_list
        });

        var _iterator = _createForOfIteratorHelper(result.channel_state.channel_asset_list),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var asset = _step.value;

            if (asset.smart_contract === kChannels.depositAddress) {
              _this.state$.update({
                balance: eth_sdk_1.toBN(asset.value)
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      channelWebSocketConnection.onopen = function () {
        notification.publish(constants_1.NotificationTypes.KChannelsWebSocketConnectionOpened, 'Channel connection has been opened.');
      };

      channelWebSocketConnection.onclose = function (event) {
        var message = 'Channel connection has been unexpectedly closed.';

        if (event.wasClean) {
          message = 'Channel connection has been closed by server.';
        }

        notification.publish(constants_1.NotificationTypes.KChannelsWebSocketConnectionClosed, message);
      };

      this.state$.update({
        channelWsConnection: channelWebSocketConnection
      });
    }
  }, {
    key: "hasValidSigners",
    value: function hasValidSigners(senderAddressList, authKeyAddresses) {
      if (authKeyAddresses.length === 0) {
        return true;
      }

      if (authKeyAddresses.length !== senderAddressList.length) {
        return false;
      }

      return authKeyAddresses.every(function (a) {
        return senderAddressList.includes(a);
      });
    }
  }, {
    key: "getOwnerAuthKeyAddresses",
    value: function getOwnerAuthKeyAddresses() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$sdk4, platform, account, authKeys;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$sdk4 = this.sdk, platform = _this$sdk4.clients.platform, account = _this$sdk4.modules.account;
                _context4.next = 3;
                return platform.getAccountAuthKeys({
                  account: account.address
                });

              case 3:
                authKeys = _context4.sent;
                return _context4.abrupt("return", authKeys.items.filter(function (i) {
                  return i.type === constants_1.AccountAuthKeyTypes.Owner;
                }).sort(function (a, b) {
                  return a.createdAt.getTime() - b.createdAt.getTime();
                }).map(function (i) {
                  return i.address;
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "createTransactionWebSocketConnection",
    value: function createTransactionWebSocketConnection() {
      var result = this.state;

      if (!result) {
        throw new Error('you must authenticate first.');
      }

      if (result.txWsConnection) {
        result.txWsConnection.close();
        this.state$.update({
          txWsConnection: null
        });
      }

      var _this$sdk5 = this.sdk,
          kChannels = _this$sdk5.clients.kChannels,
          notification = _this$sdk5.modules.notification;
      var transactionWebSocketConnection = kChannels.createTransactionWebSocketConnection(this.state$.getValue().zoneLocation.zone_client_endpoint, this.state$.getValue().channelDefinition, this.state$.getValue().jwt);

      transactionWebSocketConnection.onmessage = function (message) {
        var result = JSON.parse(message.data);
        notification.publish(constants_1.NotificationTypes.KChannelsTransaction, result);
      };

      transactionWebSocketConnection.onopen = function () {
        notification.publish(constants_1.NotificationTypes.KChannelsWebSocketConnectionOpened, 'Transaction connection has been opened.');
      };

      transactionWebSocketConnection.onclose = function () {
        notification.publish(constants_1.NotificationTypes.KChannelsWebSocketConnectionClosed, 'Transaction connection has been closed by server.');
      };

      this.state$.update({
        txWsConnection: transactionWebSocketConnection
      });
    }
  }, {
    key: "transact",
    value: function transact(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var result, transaction, transactions, transactionSummary;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                result = this.state;

                if (result) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('you must authenticate first');

              case 3:
                if (!(!result.channelDefinition || !result.zoneLocation)) {
                  _context5.next = 5;
                  break;
                }

                throw new Error('you must create a channel first');

              case 5:
                this.validateTokenExpiration();
                _context5.next = 8;
                return this.createTransaction(options);

              case 8:
                transaction = _context5.sent;
                transaction = this.signTransactionTypedMessage(transaction, constants_1.EIP712SignaturePrimaryTypes.Transaction);
                _context5.next = 12;
                return this.processTransaction(transaction, options);

              case 12:
                transactions = _context5.sent;
                transactionSummary = this.signTransactionTypedMessage(transactions[1], constants_1.EIP712SignaturePrimaryTypes.TransactionSummary);
                return _context5.abrupt("return", this.completeTransaction(transactionSummary, options));

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "withdraw",
    value: function withdraw(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var account, transactOptions;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                account = this.sdk.modules.account;
                transactOptions = {
                  recipient: account.address,
                  tokenAddress: options.tokenAddress,
                  forceExternalTransaction: true,
                  subtractFeesFromValue: options.subtractFeesFromValue,
                  value: options.value,
                  searchByDepositAddress: options.searchByDepositAddress,
                  channelUUID: options.channelUUID,
                  channelDefinitionVersion: options.channelDefinitionVersion,
                  zoneClientEndpoint: options.zoneClientEndpoint
                };
                return _context6.abrupt("return", this.transact(transactOptions));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "createTransaction",
    value: function createTransaction(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this$sdk6, kChannels, authKey, channelDefinition, args, zoneClientEndpoint, createTransactionResponse;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this$sdk6 = this.sdk, kChannels = _this$sdk6.clients.kChannels, authKey = _this$sdk6.modules.authKey;
                channelDefinition = this.state$.getValue().channelDefinition;
                args = [authKey.address, options.channelUUID ? options.channelUUID : channelDefinition.channel_uuid, options.channelDefinitionVersion ? options.channelDefinitionVersion : channelDefinition.definition_version, options.recipient, [{
                  smart_contract: options.tokenAddress ? options.tokenAddress : kChannels.depositAddress,
                  value: options.value,
                  kind: 'Value'
                }], options.forceExternalTransaction, null, options.subtractFeesFromValue, options.searchByDepositAddress];
                zoneClientEndpoint = options.zoneClientEndpoint ? options.zoneClientEndpoint : this.state$.getValue().zoneLocation.zone_client_endpoint;
                _context7.next = 6;
                return kChannels.createNewTransaction(zoneClientEndpoint, args, this.state$.getValue().jwt);

              case 6:
                createTransactionResponse = _context7.sent;
                return _context7.abrupt("return", createTransactionResponse.result);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "processTransaction",
    value: function processTransaction(transaction, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var kChannels, channelDefinition, args, zoneClientEndpoint, processTransactionResponse;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                kChannels = this.sdk.clients.kChannels;
                channelDefinition = this.state$.getValue().channelDefinition;
                args = [transaction, options.channelUUID ? options.channelUUID : channelDefinition.channel_uuid, options.channelDefinitionVersion ? options.channelDefinitionVersion : channelDefinition.definition_version];
                zoneClientEndpoint = options.zoneClientEndpoint ? options.zoneClientEndpoint : this.state$.getValue().zoneLocation.zone_client_endpoint;
                _context8.next = 6;
                return kChannels.processTransaction(zoneClientEndpoint, args, this.state$.getValue().jwt);

              case 6:
                processTransactionResponse = _context8.sent;
                return _context8.abrupt("return", processTransactionResponse.result);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "completeTransaction",
    value: function completeTransaction(transactionSummary, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var kChannels, channelDefinition, args, zoneClientEndpoint, completeTransactionResponse;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                kChannels = this.sdk.clients.kChannels;
                channelDefinition = this.state$.getValue().channelDefinition;
                args = [transactionSummary, options.channelUUID ? options.channelUUID : channelDefinition.channel_uuid, options.channelDefinitionVersion ? options.channelDefinitionVersion : channelDefinition.definition_version];
                zoneClientEndpoint = options.zoneClientEndpoint ? options.zoneClientEndpoint : this.state$.getValue().zoneLocation.zone_client_endpoint;
                _context9.next = 6;
                return kChannels.completeTransaction(zoneClientEndpoint, args, this.state$.getValue().jwt);

              case 6:
                completeTransactionResponse = _context9.sent;
                return _context9.abrupt("return", completeTransactionResponse.result);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "signTransactionTypedMessage",
    value: function signTransactionTypedMessage(transaction, primaryType) {
      var _this$sdk7 = this.sdk,
          kChannels = _this$sdk7.clients.kChannels,
          authKey = _this$sdk7.modules.authKey;
      var transactionTypedMessage = kChannels.getTransactionTypedMessage(transaction, primaryType);
      var signedMessage = authKey.signTypedMessage(transactionTypedMessage);
      transaction['signature_list'] = [signedMessage];
      return transaction;
    }
  }, {
    key: "validateTokenExpiration",
    value: function validateTokenExpiration() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var result, dateNow;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                result = this.state;
                dateNow = new Date().getTime() / 1000;

                if (!(dateNow >= result.exp)) {
                  _context10.next = 5;
                  break;
                }

                _context10.next = 5;
                return this.authenticate();

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.getValue();
    }
  }, {
    key: "channelDefinition",
    get: function get() {
      return this.state.channelDefinition;
    }
  }, {
    key: "jwt",
    get: function get() {
      return this.state.jwt;
    }
  }, {
    key: "exp",
    get: function get() {
      return this.state.exp;
    }
  }]);

  return KChannelsModule;
}();

exports.KChannelsModule = KChannelsModule;

(function (KChannelsModule) {
  var State = /*#__PURE__*/function (_utils_1$StateSubject) {
    _inherits(State, _utils_1$StateSubject);

    var _super = _createSuper(State);

    function State() {
      _classCallCheck(this, State);

      return _super.call(this);
    }

    return State;
  }(utils_1.StateSubject);

  KChannelsModule.State = State;
})(KChannelsModule = exports.KChannelsModule || (exports.KChannelsModule = {}));